var safe_area = function (scene) {
    var _a = scene.scale, width = _a.width, height = _a.height, displaySize = _a.displaySize, displayScale = _a.displayScale;
    var diff_x = displaySize.width - window.innerWidth;
    var diff_y = displaySize.height - window.innerHeight;
    var x_min = (diff_x / 2) * displayScale.x;
    var x_max = diff_x > 0 ? x_min + window.innerWidth * displayScale.x : width;
    var y_min = (diff_y / 2) * displayScale.y;
    var y_max = diff_y > 0 ? y_min + window.innerHeight * displayScale.y : height;
    // const graphics = new Phaser.GameObjects.Graphics(scene);
    // // top - left
    // graphics.fillStyle(0xff0000, 0.4);
    // graphics.fillRect(x_min, y_min, 100, 100);
    // // top - right
    // graphics.fillStyle(0x00ff00, 0.4);
    // graphics.fillRect(x_max - 100, y_min, 100, 100);
    // // bottom - left
    // graphics.fillStyle(0x0000ff, 0.4);
    // graphics.fillRect(x_min, y_max - 100, 100, 100);
    // // bottom - right
    // graphics.fillStyle(0xff00ff, 0.4);
    // graphics.fillRect(x_max - 100, y_max - 100, 100, 100);
    // // top - mid
    // graphics.fillStyle(0xffff00, 0.4);
    // graphics.fillRect(width / 2 - 50, y_min, 100, 100);
    // // bottom - mid
    // graphics.fillStyle(0x55aa55, 0.4);
    // graphics.fillRect(width / 2 - 50, y_max - 100, 100, 100);
    // // mid - left
    // graphics.fillStyle(0xff00ff, 0.4);
    // graphics.fillRect(x_min, height / 2 - 50, 100, 100);
    // // mid - right
    // graphics.fillStyle(0x00ffff, 0.4);
    // graphics.fillRect(x_max - 100, height / 2 - 50, 100, 100);
    // // center
    // graphics.fillStyle(0xffffff, 0.4);
    // graphics.fillRect(width / 2 - 50, height / 2 - 50, 100, 100);
    // graphics.setScrollFactor(0);
    // graphics.setDepth(999999999999999999999);
    // scene.add.existing(graphics);
    return {
        x_min: x_min,
        x_max: x_max,
        y_min: y_min,
        y_max: y_max,
        width: width,
        height: height,
    };
};
var UtilsScreen = {
    safe_area: safe_area,
};
export default UtilsScreen;
